<script setup>
// Czas od startu zawodnika w trasie, odświeżany co sekundę wspólnym zegarem (tylko ten element).
import { computed, defineProps } from 'vue'
import { useNowTick } from '../../utils/now-tick.js'
import { formatDuration } from '../../utils/polish-time.js'

const props = defineProps({
  startMs: { type: Number, default: null },
  // bez sekund: "29:41" (telefon i „teraz” w /ar)
  short: { type: Boolean, default: false }
})
const now = useNowTick()
const text = computed(() => {
  if (props.startMs == null || now.value < props.startMs) return ''
  const full = formatDuration(now.value - props.startMs)
  return props.short ? full.slice(0, -3) : full
})
</script>

<template>
  <span class="running-time">{{ text }}</span>
</template>

<style scoped>
.running-time {
  font-style: italic;
  font-variant-numeric: tabular-nums;
  color: var(--sledz-text-secondary);
}
</style>
